import { render, staticRenderFns } from "./ContentPerformance.vue?vue&type=template&id=25b18a4e&scoped=true&"
import script from "./ContentPerformance.vue?vue&type=script&lang=js&"
export * from "./ContentPerformance.vue?vue&type=script&lang=js&"
import style0 from "./ContentPerformance.vue?vue&type=style&index=0&id=25b18a4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b18a4e",
  null
  
)

export default component.exports